import React, { FC } from 'react'

type Props = {
  className?: string
}

export const ArrowDown: FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="11"
      fill="none"
    >
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-miterlimit="10"
        d="M18.03 1.11 9.57 9.57 1 1"
      />
    </svg>
  )
}
